import React from "react";
import { Input } from "@progress/kendo-react-inputs";
import { icon, label, number, tooltip } from "../../../config";
import { queueCardIcons } from "../queue.constants";

/**
 * Queue card header component for displaying queue name and actions
 * @author Bhavana
 */
const QueueCardHeader = ({ index, gridRow, QueueName, RoleId, isEditing, editedName, isQueueBookmarked, queueCardHook }) => {
  const {
    // State
    queueNameEdits,
    setQueueNameEdits,
    setQueueNameEditIndex,
    hoveredQueueName,
    setHoveredQueueName,

    // Handlers
    handleQueueNameSave,
    handleBookmarkFunction,
    handleViewChange,
  } = queueCardHook;

  return (
    <div className='queue-card-header'>
      <div
        className='d-flex align-items-center queue-name-container text-truncate'
        onMouseEnter={() => setHoveredQueueName(index)}
        onMouseLeave={() => setHoveredQueueName(null)}>
        <span
          className='cursor-pointer grey d-flex'
          onClick={(e) => {
            e.stopPropagation();
            handleBookmarkFunction(gridRow?.QueueId);
          }}
          title={isQueueBookmarked ? label?.REMOVE_FAVORITE : tooltip.ADD_TO_FAVORITES}>
          {isQueueBookmarked ? icon?.FAVORITE : icon?.MARK_FAVORITE}
        </span>

        <span className='queue-name text-truncate'>
          {isEditing ? (
            <Input
              type='text'
              className='queue-name-input'
              value={editedName}
              onChange={(e) => setQueueNameEdits((edits) => ({ ...edits, [index]: e?.value }))}
              maxLength={120}
            />
          ) : (
            <span
              onClick={() => {
                if (RoleId === number.TWO) {
                  handleViewChange(label.GRID, gridRow);
                }
              }}>
              {QueueName}
            </span>
          )}
        </span>

        {RoleId === number.TWO && (
          <span className='cursor-pointer grey ml-1 invisible'>
            <span
              onClick={() => {
                if (isEditing) {
                  handleQueueNameSave(index, gridRow?.QueueId);
                } else {
                  setQueueNameEditIndex(index);
                  setQueueNameEdits((edits) => ({ ...edits, [index]: QueueName }));
                }
              }}>
              {isEditing ? (
                <span className='queue-edit-icon'>{icon?.BOOKMARK_NAME}</span>
              ) : (
                <span className='queue-edit-icon' title='Edit Name'>
                  {icon?.EDIT_ICON}
                </span>
              )}
            </span>
          </span>
        )}
      </div>

      {RoleId === number.TWO && !isEditing && (
        <div className='queue-icons-container'>
          {queueCardIcons?.map(({ label, icon, text }) => (
            <div
              key={label}
              className='queue-icon-item cursor-pointer'
              onClick={() => {
                handleViewChange(text, gridRow);
              }}>
              <span>
                <span className='queue-icon'>{icon}</span>
                <span className='queue-text'>{label}</span>
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default QueueCardHeader;
